var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.53066C10.7711 1.53066 11.04 1.54062 11.9332 1.58047C12.7633 1.61699 13.2115 1.75645 13.5104 1.87266C13.9055 2.02539 14.191 2.21133 14.4865 2.50684C14.7854 2.80566 14.968 3.08789 15.1207 3.48301C15.2369 3.78184 15.3764 4.2334 15.4129 5.06016C15.4527 5.95664 15.4627 6.22559 15.4627 8.49336C15.4627 10.7645 15.4527 11.0334 15.4129 11.9266C15.3764 12.7566 15.2369 13.2049 15.1207 13.5037C14.968 13.8988 14.782 14.1844 14.4865 14.4799C14.1877 14.7787 13.9055 14.9613 13.5104 15.1141C13.2115 15.2303 12.76 15.3697 11.9332 15.4062C11.0367 15.4461 10.7678 15.4561 8.5 15.4561C6.22891 15.4561 5.95996 15.4461 5.0668 15.4062C4.23672 15.3697 3.78848 15.2303 3.48965 15.1141C3.09453 14.9613 2.80898 14.7754 2.51348 14.4799C2.21465 14.1811 2.03203 13.8988 1.8793 13.5037C1.76309 13.2049 1.62363 12.7533 1.58711 11.9266C1.54727 11.0301 1.5373 10.7611 1.5373 8.49336C1.5373 6.22227 1.54727 5.95332 1.58711 5.06016C1.62363 4.23008 1.76309 3.78184 1.8793 3.48301C2.03203 3.08789 2.21797 2.80234 2.51348 2.50684C2.8123 2.20801 3.09453 2.02539 3.48965 1.87266C3.78848 1.75645 4.24004 1.61699 5.0668 1.58047C5.95996 1.54062 6.22891 1.53066 8.5 1.53066ZM8.5 0C6.19238 0 5.90352 0.00996094 4.99707 0.0498047C4.09395 0.0896484 3.47305 0.235742 2.93516 0.444922C2.37402 0.664062 1.89922 0.95293 1.42773 1.42773C0.95293 1.89922 0.664062 2.37402 0.444922 2.93184C0.235742 3.47305 0.0896484 4.09062 0.0498047 4.99375C0.00996094 5.90352 0 6.19238 0 8.5C0 10.8076 0.00996094 11.0965 0.0498047 12.0029C0.0896484 12.9061 0.235742 13.527 0.444922 14.0648C0.664062 14.626 0.95293 15.1008 1.42773 15.5723C1.89922 16.0437 2.37402 16.3359 2.93184 16.5518C3.47305 16.7609 4.09062 16.907 4.99375 16.9469C5.9002 16.9867 6.18906 16.9967 8.49668 16.9967C10.8043 16.9967 11.0932 16.9867 11.9996 16.9469C12.9027 16.907 13.5236 16.7609 14.0615 16.5518C14.6193 16.3359 15.0941 16.0437 15.5656 15.5723C16.0371 15.1008 16.3293 14.626 16.5451 14.0682C16.7543 13.527 16.9004 12.9094 16.9402 12.0063C16.9801 11.0998 16.99 10.8109 16.99 8.50332C16.99 6.1957 16.9801 5.90684 16.9402 5.00039C16.9004 4.09727 16.7543 3.47637 16.5451 2.93848C16.3359 2.37402 16.0471 1.89922 15.5723 1.42773C15.1008 0.95625 14.626 0.664062 14.0682 0.448242C13.527 0.239062 12.9094 0.0929688 12.0063 0.053125C11.0965 0.00996094 10.8076 0 8.5 0Z",
    fill: "url(#paint0_linear_276_5072)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.13379C6.08945 4.13379 4.13379 6.08945 4.13379 8.5C4.13379 10.9105 6.08945 12.8662 8.5 12.8662C10.9105 12.8662 12.8662 10.9105 12.8662 8.5C12.8662 6.08945 10.9105 4.13379 8.5 4.13379ZM8.5 11.3322C6.93613 11.3322 5.66777 10.0639 5.66777 8.5C5.66777 6.93613 6.93613 5.66777 8.5 5.66777C10.0639 5.66777 11.3322 6.93613 11.3322 8.5C11.3322 10.0639 10.0639 11.3322 8.5 11.3322Z",
    fill: "url(#paint1_linear_276_5072)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0582 3.96114C14.0582 4.52559 13.6 4.98048 13.0389 4.98048C12.4744 4.98048 12.0195 4.52227 12.0195 3.96114C12.0195 3.39669 12.4777 2.9418 13.0389 2.9418C13.6 2.9418 14.0582 3.40001 14.0582 3.96114Z",
    fill: "url(#paint2_linear_276_5072)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_276_5072",
    x1: 8.49502,
    y1: -3.55385,
    x2: 8.49502,
    y2: 22.9455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B556FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151042,
    stopColor: "#D34BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FF0FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#FF2070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FF035E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#FF6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#FF8C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#FFCD1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_276_5072",
    x1: 8.5,
    y1: 2.30792,
    x2: 8.5,
    y2: 15.9226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B556FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151042,
    stopColor: "#D34BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FF0FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#FF2070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FF035E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#FF6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#FF8C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#FFCD1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_276_5072",
    x1: 13.0389,
    y1: 2.51553,
    x2: 13.0389,
    y2: 5.69401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B556FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151042,
    stopColor: "#D34BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FF0FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#FF2070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FF035E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#FF6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#FF8C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#FFCD1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.16dec375a510ca3172d5256274bf691e.svg";
export { ForwardRef as ReactComponent };